// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1FNDz","requiredAsterisk":"Info_requiredAsterisk__3YTP9"};